// to validate the order id format (only numbers)
export const validOrderID = RegExp(/^[0-9\b]+$/);

// to validate the tracking id (numbers and - symbol)
export const validTrackingID = RegExp(/^[0-9-]+$/);

// phone number can either start with + or number
// () to hold country number , - to separate
export const validPhoneNumber = RegExp(/^(\+)?[0-9)(-]+$/);
